import { TEndpoint } from '@rbx/docsite-utilities/dist/browser';
import { getSlugForResourcePathName } from './getSlugForResourcePathName';

export type ResourcePath = { name: string; slug: string };

export const getEndpointResourcePathOptions = (endpoint: TEndpoint): ResourcePath[] => {
  // 'endpoint' is a string array of resource paths
  // TODO (@ahua) Update name to 'resourcePaths'
  return endpoint.endpoint
    .filter((pathVal) => pathVal !== '')
    .map((pathVal) => ({ name: pathVal, slug: getSlugForResourcePathName(pathVal) }))
    .sort((a, b) => a.name.length - b.name.length) as ResourcePath[];
};

export default getEndpointResourcePathOptions;
